import React from "react";
/* asset imports */
import fruitCart1 from "../assets/images/fruits/fruits-1.png";
import fruitCart2 from "../assets/images/fruits/fruits-2.png";
import fruitCart3 from "../assets/images/fruits/fruits-3.png";
import MainCartModal from "./modals/MainCartModal";

const FruitsCartLarge = ({
  handleCartClick,
  handleCartItemClick,
  activeCartData,
}) => {
  return (
    <>
      <div className="carts-main-wrapper">
        <div className="close-icon" onClick={() => handleCartClick(0)}>
          <span className="material-symbols-rounded">close</span>
        </div>
        <div className="cart-large fruits-cart-empty">
          <img
            src={fruitCart1}
            alt=""
            className="inner-img-var-2-1"
            onClick={() => handleCartItemClick("tropical-fruits")}
          />
          <img
            src={fruitCart2}
            alt=""
            className="inner-img-var-2-2"
            onClick={() => handleCartItemClick("berries")}
          />
          <img
            src={fruitCart3}
            alt=""
            className="inner-img-var-2-3"
            onClick={() => handleCartItemClick("citrus-fruits")}
          />
        </div>
      </div>
      <MainCartModal activeCartData={activeCartData} />
    </>
  );
};

export default FruitsCartLarge;
